import { useEffect, useMemo, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { http } from "@/lib/api";
import { SearchForm } from "@/components/site/SearchForm";
import { ListingCard } from "@/components/site/ListingCard";
import { PageTitle } from "@/components/site/PageTitle";

const KEYS = ["contratto", "categoria", "provincia", "comune", "prezzo_max", "riferimento", "ordine"];

export const ListingGrid = ({ params, intro = null }) => {
  const [data, setData] = useState({ items: [], total: 0 });
  const [loading, setLoading] = useState(true);
  const key = JSON.stringify(params);

  useEffect(() => {
    setLoading(true);
    http.get("/listings", { params: { ...JSON.parse(key), limit: 100 } })
      .then((r) => setData({ items: Array.isArray(r.data?.items) ? r.data.items : [], total: r.data?.total ?? 0 }))
      .catch(() => setData({ items: [], total: 0 }))
      .finally(() => setLoading(false));
  }, [key]);

  return (
    <div>
      {intro}
      <h2 data-testid="listings-count" className="font-tit font-bold text-[var(--iv)] uppercase text-2xl sm:text-[28px] mb-4">
        {loading ? "Ricerca in corso…" : `Sono stati trovati ${data.total} immobili in elenco`}
      </h2>
      {loading ? (
        <div className="py-20 grid place-items-center"><Loader2 className="w-6 h-6 animate-spin text-[var(--iv)]" /></div>
      ) : data.items.length === 0 ? (
        <p data-testid="listings-empty" className="py-10">Nessun immobile corrisponde ai criteri di ricerca.</p>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-5 gap-y-8">
          {data.items.map((l) => <ListingCard key={l.id} l={l} />)}
        </div>
      )}
    </div>
  );
};

export default function Listings() {
  const [sp] = useSearchParams();
  const params = useMemo(() => Object.fromEntries(KEYS.map((k) => [k, sp.get(k) || ""]).filter(([, v]) => v)), [sp]);

  return (
    <div data-testid="listings-page">
      <PageTitle title="Ricerca immobili" crumbs={[{ label: "Ricerca" }]} />
      <div className="max-w-[1240px] mx-auto px-4 pt-8 grid grid-cols-1 lg:grid-cols-[290px_1fr] gap-8">
        <aside>
          <h2 className="font-tit font-bold text-[var(--iv)] uppercase text-xl mb-3">Modifica la ricerca</h2>
          <SearchForm key={sp.toString()} initial={params} vertical />
        </aside>
        <ListingGrid params={params} />
      </div>
    </div>
  );
}
